<template>
    <b-sidebar id="add-new-leave-code-sidebar" :visible="isAddNewLeaveCodeSidebarActive" bg-variant="white" sidebar-class="sidebar-lg" shadow backdrop no-header right @hidden="resetForm" @change="(val) => $emit('update:is-add-new-leave-code-sidebar-active', val)">
        <template #default="{ hide }">
                  <!-- Header -->
                  <div
                    class="d-flex justify-content-between align-items-center content-sidebar-header px-2 py-1"
                  >
                    <h5 class="mb-0">{{button_text}} New Leave Code</h5>
            
                    <feather-icon
                      class="ml-1 cursor-pointer"
                      icon="XIcon"
                      size="16"
                      @click="hide"
                    />
                  </div>
            
                  <!-- Body -->
                  <validation-observer 
                    #default="{ handleSubmit }"
                    ref="refFormObserver"
                  >
                  <b-overlay
                        :show = 'loading'
                        spinner-variant="primary"
                        spinner-type="grow"
                        spinner-small
                        rounded="sm"
                        >
                    <!-- Form -->
                    <b-form
                      class="p-2"
                      @submit.prevent="handleSubmit(onSubmit)"
                      @reset.prevent="resetForm"
                    >
                      <!-- Leave Code-->
                      <validation-provider
                        #default="validationContext"
                        name="Leave Code"
                        rules="required|max:6"
                      >
                        <b-form-group label="Leave Code" label-for="leave-code">
                          <b-form-input
                            id="leave-code"
                            v-model="leavecodeData.leave_code"
                            autofocus
                            :state="getValidationState(validationContext)"
                            trim
                            placeholder="Leave Code"
                           />
                            <b-form-invalid-feedback>
                              {{ validationContext.errors[0] }}
                            </b-form-invalid-feedback>
                         
                        </b-form-group>
                      </validation-provider>
                      <!-- Description -->
                      <validation-provider
                        #default="validationContext"
                        name="Description"
                        rules="required|max:90"
                      >
                        <b-form-group label="Description" label-for="description">
                          <b-form-textarea
                            id="description"
                            v-model="leavecodeData.description"
                            autofocus
                            :state="getValidationState(validationContext)"
                            trim
                          />
                          <b-form-invalid-feedback>
                            {{ validationContext.errors[0] }}
                          </b-form-invalid-feedback>
                        </b-form-group>
                      </validation-provider>
                       <!-- Remark -->
                 
                        <b-form-group label="Remark" label-for="remark">
                          <b-form-textarea
                            id="remark"
                            v-model="leavecodeData.remark"
                            autofocus
                            trim
                          />
                        </b-form-group>
                      
                    <!-- COUNT AL BALANCE -->
                    <b-form-group>
                        <b-form-checkbox
                        checked="true"
                        name="check-button"
                        switch
                        inline
                        v-model="leavecodeData.count_al_balance"
                        >
                            Count Al Balance
                        </b-form-checkbox>  
                    </b-form-group>
                    <!-- Require Reason -->
                    <b-form-group>
                        <b-form-checkbox
                        checked="true"
                        name="check-button"
                        switch
                        inline
                        v-model="leavecodeData.reason_bit"
                        >
                            Require Reason
                        </b-form-checkbox>  
                    </b-form-group>   
                      <!-- Form Actions -->
                      
                      <div class="d-flex mt-2">
                        <b-button
                          v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                          variant="primary"
                          class="mr-2"
                          type="submit"
                        >
                          {{button_text}}
                        </b-button>
                        <b-button
                          v-ripple.400="'rgba(186, 191, 199, 0.15)'"
                          type="button"
                          variant="outline-secondary"
                          @click="hide"
                        >
                          Cancel
                        </b-button>
                      </div>
                      
                    </b-form>
                    </b-overlay>
                  </validation-observer>
</template>
  </b-sidebar>
</template>

<script>
import {
    BSidebar,
    BForm,
    BFormGroup,
    BFormInput,
    BFormInvalidFeedback,
    BButton,
    BFormTextarea,
    BFormCheckbox,
    BOverlay,
} from "bootstrap-vue";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import { ref, watch } from "@vue/composition-api";
import { required, alphaNum, email } from "@validations";
import { max } from "@/libs/validations.js"
import formValidation from "@core/comp-functions/forms/form-validation";
import Ripple from "vue-ripple-directive";
import vSelect from "vue-select";
import store from "@/store";
import { useToast } from 'vue-toastification/composition'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'

export default {
    components: {
        BSidebar,
        BForm,
        BFormGroup,
        BFormInput,
        BFormInvalidFeedback,
        BButton,
        BFormTextarea,
        BFormCheckbox,
        vSelect,
        BOverlay,

        // Form Validation
        ValidationProvider,
        ValidationObserver,
    },
    directives: {
        Ripple,
    },
    model: {
        prop: 'isAddNewLeaveCodeSidebarActive',
        event: 'update:is-add-new-leave-code-sidebar-active',
    },
    props: {
        isAddNewLeaveCodeSidebarActive: {
            type: Boolean,
            required: true,
        },
        id: {
            type: Number,
            required: true,
        },
        data: {
            type: Object,
            required: true,
        }
    },
    data() {
        return {
            required,
            alphaNum,
            email,
            max,
        }
    },
    setup(props, { emit }) {

        const loading = ref(false)

        const blankLeaveCodeData = {
            id: 0,
            leave_code: '',
            description: '',
            remark: '',
            reason_bit: false,
            count_al_balance: false,
        }
        const button_text = ref('Add')

        const leavecodeData = ref(JSON.parse(JSON.stringify(blankLeaveCodeData)))

        const resetleavecodeData = () => {
            leavecodeData.value = JSON.parse(JSON.stringify(blankLeaveCodeData))
        }

        const toast = useToast()

        watch(() => [props.id, props.isAddNewLeaveCodeSidebarActive], () => {
            if (props.id > 0 && props.isAddNewLeaveCodeSidebarActive) {
                leavecodeData.value.id = props.data.id
                leavecodeData.value.leave_code = props.data.leave_code
                leavecodeData.value.description = props.data.description
                leavecodeData.value.remark = props.data.remark
                leavecodeData.value.count_al_balance = props.data.count_al_balance == 1 ? true : false
                leavecodeData.value.reason_bit = props.data.reason_bit == 1 ? true : false
                
                if (leavecodeData.value.id > 0) {
                    button_text.value = 'Edit'
                } else {
                    button_text.value = 'Add'
                }
            } else {
                button_text.value = 'Add'
            }


        })

        const onSubmit = () => {
            loading.value = true
            store.dispatch("setting-leavecode/addLeaveCode", leavecodeData.value)
                .then((response) => {
                    loading.value = false
                    emit("update:is-add-new-leave-code-sidebar-active", false);
                    emit('refetch-data')
                    toast({
                        component: ToastificationContent,
                        props: {
                            title: 'Success',
                            text: response.data.message,
                            icon: 'CheckIcon',
                            variant: 'success'
                        }
                    })
                })
                .catch((error) => {
                    loading.value = false
                    toast({
                        component: ToastificationContent,
                        props: {
                            title: 'Fail',
                            text: error.response.data.message,
                            icon: 'HeartIcon',
                            variant: 'danger'
                        }
                    })
                })
        };

        const {
            refFormObserver,
            getValidationState,
            resetForm,
        } = formValidation(resetleavecodeData)

        return {
            leavecodeData,
            onSubmit,
            refFormObserver,
            getValidationState,
            resetForm,
            button_text,
            loading,
        };


    }

};
</script>

</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
#add-new-leave-code-sidebar {
    .vs__dropdown-menu {
        max-height: 200px !important;
    }
}
</style>